<template>
  <div
    :class="{
      lottery_container: true,
      bg_26: prizeList.length == 26,
      bg_20: prizeList.length == 20,
      bg_14: prizeList.length == 14
    }"
  >
    <span @click="share" class="share" v-show="isAPP ? true : false"></span>
    <div class="header">
      <section class="header-container">
        <Header :options="userWallet" @getRecordlist="getRecordlist" @toRecharge="toRecharge"></Header>
      </section>
    </div>
    <div class="tab">
      <div class="select-container">
        <Tab v-model="currentSelectid">
          <containerSelectOptions
            v-for="item in selectOption"
            :key="item.lotteryId"
            :label="item.label"
            :value="item.lotteryId + ''"
            :iconbg="item.iconbg"
            :lotteryId="item.lotteryId"
            :lotteryPrice="item.lotteryPrice"
            :freeLottery="item.freeLottery"
            @change="changeHandler"
          ></containerSelectOptions>
        </Tab>
      </div>
    </div>
    <p class="lottery_text">抽奖次数越多，抽中稀有概率越大呦～</p>
    <div class="map">
      <MapType :prizeList="prizeList" :seatNumber="im_here"></MapType>
    </div>
    <div :class="{ btn: true, scrollFlag: scrollFlag }" ref="btn">
      <div class="shake-sieve-container">
        <ul>
          <li
            :class="{ container: true, special: index == 1 ? true : false }"
            v-for="(item, index) in lotteryButtonList"
            :key="index"
            @click="isAPP ? doAnimate(item.lotteryButtonId) : wx_share()"
          >
            <p v-if="item.lotteryButtonId == -1">
              {{ item.lotteryCountPrice == 0 ? "白摇" : "摇"
              }}
              <span class="blue-color">{{ item.lotteryCount }}</span>次
              <span v-if="item.lotteryCountPrice !== 0" class="blue-color">
                {{
                item.lotteryCountPrice
                }}
              </span>
              <span
                v-if="item.lotteryCountPrice !== 0"
                :class="{
                  'zhuan-bg': true,
                  dimaon: item.lotteryCountPriceType == 2 ? true : false,
                  jinbi: item.lotteryCountPriceType == 1 ? true : false,
                  mining: item.lotteryCountPriceType == 3 ? true : false
                }"
              ></span>
            </p>
            <p v-else>
              连摇
              <span class="blue-color">{{ item.lotteryCount }}</span>次
              <span class="blue-color">{{ item.lotteryCountPrice }}</span>
              <span
                :class="{
                  'zhuan-bg': true,
                  dimaon: item.lotteryCountPriceType == 2 ? true : false,
                  jinbi: item.lotteryCountPriceType == 1 ? true : false,
                  mining: item.lotteryCountPriceType == 3 ? true : false
                }"
              ></span>
            </p>
            <p class="litter-fz" v-show="item.mustWinPrize == 1"></p>
          </li>
        </ul>
        <p
          class="video_img"
          @click="isAPP ? getVideo() : wx_share()"
          v-if="watchAdvertFreeLottery == 1 ? true: false"
        ></p>
      </div>
    </div>
    <div class="animate">
      <div class="animateAndResult" v-if="isShowAnimateBoxFlag || isShowResultBoxFlag">
        <div class="animate-gif" v-if="isShowAnimateBoxFlag"></div>
        <div class="result" v-if="isShowResultBoxFlag">
          <div
            v-if="!isSingleOrContinuity"
            class="signleBox"
            :style="{ backgroundImage: `url(${singleResultImgUrl})` }"
          >
            <div class="closeBtn" @click="closeResultBox"></div>
            <p class="step_num">前进{{ dicePoint }}步</p>
          </div>
          <div
            v-else
            class="continuityBox"
            :style="{ backgroundImage: `url(${continuityResultImgUrl})` }"
          >
            <div class="continuityNumbers">
              <ul>
                <li
                  v-for="(item, index) in cishuImgArr"
                  :key="index"
                  :style="{ backgroundImage: `url(${item})` }"
                ></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rules">
      <Rules></Rules>
    </div>
    <div class="result_info">
      <Result
        v-if="isResult"
        @CloseResult="CloseResult"
        :isSingleOrContinuity="isSingleOrContinuity"
        @doAnimatAgain="doAnimatAgain"
        :lottery_list="lotteryPrizeList"
        :continuity_num="doubleCount"
        :singlemoney="singlemoney"
        :contiueBtnId="contiueBtnId"
        :icon_img="icon_img"
        :continuitymoney="doubleshakemoney"
      ></Result>
    </div>
    <div class="lotter_list">
      <Lotterylist
        v-if="isRecordlist"
        @closeRercod="closeRercod"
        :options="options"
        :currentPage="pageNum"
        :isLastPage="isLastPage"
      ></Lotterylist>
    </div>
    <Appopen
      :title="'我是谜app打开方式'"
      :browser="'1.' + '点击右上角[...]'"
      :direct="'2.' + '选择[在浏览器中打开]'"
      :isAppopen="isAppopen"
    ></Appopen>
    <p
      class="ios_notic"
      v-if="getPlatform() == 2 && isAPP ? true : false"
    >特别声明：本活动为 我是谜 举办 ，与Apple Inc.无关</p>
    <p class="isSimulator_notic" v-if="isSimulator">{{this.isSimulatorMessage}}</p>
  </div>
</template>
<script>
import _ from "lodash";
import { Indicator, Toast } from "mint-ui";
import axios from "axios";
import { appUrlAndroid, appUrlIOS } from "../../../assets/js/base64";
const diceObj = {
  1: require("../../../assets/images/lottery/dice/dice_1.png"),
  2: require("../../../assets/images/lottery/dice/dice_2.png"),
  3: require("../../../assets/images/lottery/dice/dice_3.png"),
  4: require("../../../assets/images/lottery/dice/dice_4.png"),
  5: require("../../../assets/images/lottery/dice/dice_5.png"),
  6: require("../../../assets/images/lottery/dice/dice_6.png")
};
let _timer = null;
const numberImgArr = {
  0: require("../../../assets/images/lottery/num/0.png"),
  1: require("../../../assets/images/lottery/num/1.png"),
  2: require("../../../assets/images/lottery/num/2.png"),
  3: require("../../../assets/images/lottery/num/3.png"),
  4: require("../../../assets/images/lottery/num/4.png"),
  5: require("../../../assets/images/lottery/num/5.png"),
  6: require("../../../assets/images/lottery/num/6.png"),
  7: require("../../../assets/images/lottery/num/7.png"),
  8: require("../../../assets/images/lottery/num/8.png"),
  9: require("../../../assets/images/lottery/num/9.png"),
  x: require("../../../assets/images/lottery/num/x.png")
};
export default {
  data() {
    return {
      token: "",
      userguid: "",
      isAppopen: false,
      isResult: false,
      isAnimate: false,
      isMap: true,
      isRecordlist: false,
      //动画相关
      isShowAnimateBoxFlag: false, // 展示动画开关
      isShowResultBoxFlag: false, // 展示结果开关
      isSingleOrContinuity: false, // 单摇false 连摇true
      userWallet: {},
      currentSelectid: "", //选中tab id
      selectOption: [],
      options: [], //中奖记录
      lotteryId: "",
      prizeList: [],
      isTagHere: false,
      lotteryPrizeList: [],
      freeLottery: "",
      icon_img: "",
      //btn
      lotteryButtonList: [],
      cishu: 0,
      cishuImgArr: [],
      //单摇次数
      singleNum: 0,
      //单摇
      singleResultImgUrl: "",
      //连摇次数
      continuityNum: 0,
      //连摇
      continuityResultImgUrl: "",
      scrollFlag: true,
      btntype: "",
      doubleCount: "",
      singlemoney: 1,
      pageNum: "",
      pageSize: 10,
      isLastPage: "",
      dicePoint: "", //骰子的点数
      im_here: "",
      watchAdvertFreeLottery: "",
      isSimulator: false, //安卓模拟器标识
      isSimulatorMessage: ""
    };
  },
  created() {
    document.getElementsByTagName("title")[0].innerText = "我是谜-每日一抽";
    this.Url = window.location.href;
    var u = navigator.userAgent,
      app = navigator.appVersion;
    this.isAPP = new RegExp("WSMAPP WSM").test(u);
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (this.isAPP) {
      this.getInfo().then(res => {
        // console.log(res)
        const jsonObj = JSON.parse(res);
        this.token = jsonObj.token;
        this.userguid = jsonObj.userguid;
        if (this.isAndroid) {
          this.deviceVerify = jsonObj.deviceVerify;
          window.localStorage.setItem("deviceVerify", this.deviceVerify);
        }
        window.localStorage.setItem("token", this.token);
        window.localStorage.setItem("userguid", this.userguid);
        this.nickname = jsonObj.nickname;
        this.getLotteryList();
      });
    } else {
      this.getLotteryList();
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", _.throttle(this.handleScroll, 100));
    this.im_here = this.singleNum;
    //客户端调用js的方法 将getUserWallet方法挂载到window上
    window["getUserWallet"] = () => {
      this.getLotteryList(this.lotteryId);
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    changeHandler(img, val, lotteryId) /**切换tab */ {
      this.lotteryId = lotteryId;
      this.getLotteryList(this.lotteryId);
    },
    getinit(parmas) /**初始化tab文案 */ {
      this.selectOption = JSON.parse(JSON.stringify(parmas));
      this.selectOption.forEach(item => {
        this.freeLottery = item.freeLottery == 1 ? true : false;
        if (this.freeLottery) {
          item.label = "免费";
          item.freeLottery = this.freeLottery;
        } else {
          item.freeLottery = !this.freeLottery;
          if (item.lotteryPriceType == 1) {
            item.iconbg = "jinbi";
            item.label = item.lotteryPrice + "金";
          } else if (item.lotteryPriceType == 2) {
            item.iconbg = "dimaon";
            item.label = item.lotteryPrice + "钻";
          } else {
            item.iconbg = "mining";
            item.label = item.lotteryPrice + "矿";
          }
        }
        this.currentSelectid = this.freeLottery ? "free" : this.lotteryId;
      });
    },
    handleScroll() {
      let _this = this;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop) {
        _this.scrollFlag = false;
      } else {
        _this.scrollFlag = true;
      }
    },
    getImgArr(num) {
      this.cishuImgArr = [];
      this.cishuImgArr.push(numberImgArr["x"]);
      if (num < 10) {
        this.cishuImgArr.push(numberImgArr[num]);
      } else {
        let numArr = (num + "").split("");
        numArr.forEach(v => {
          this.cishuImgArr.push(numberImgArr[v]);
        });
      }
    },
    shakeSingle(buttonid) /**单摇 */ {
      window.scrollTo(0, 0);
      this.shakeNetwork(buttonid);
    },
    closeResultBox() /**关闭抽奖动画结果弹窗*/ {
      this.isShowResultBoxFlag = false;
      this.isResult = true;
    },
    shakeContinuity(buttonid) /**连摇 */ {
      window.scrollTo(0, 0);
      this.shakeNetwork(buttonid);
    },
    shakeNetwork(buttonId) {
      let parmas = {
        userGuid: localStorage.getItem("userguid"),
        token: localStorage.getItem("token"),
        platform: this.getPlatform(),
        lotteryId: this.lotteryId,
        buttonId: buttonId
      };
      let DeviceVerify = window.localStorage.getItem("deviceVerify"); //模拟器标识
      if (
        this.isAndroid &&
        (DeviceVerify == false || DeviceVerify == "false")
      ) {
        this.isSimulator = true;
        this.isSimulatorMessage = "请使用移动端设备打开最新版APP参与抽奖";
        clearTimeout(_timer);
        _timer = setTimeout(() => {
          this.isSimulator = false;
        }, 3000);
      } else {
        this.Axios(buttonId, parmas);
      }
    },
    doAnimate(btnType) /**动画类型*/ {
      if (btnType !== -1) {
        this.isSingleOrContinuity = true;
        this.shakeContinuity(btnType);
      } else if (btnType == -1) {
        this.isSingleOrContinuity = false;
        this.shakeSingle(btnType);
      }
    },
    doAnimatAgain(parmas) {
      this.CloseResult();
      if (parmas !== -1) {
        this.isSingleOrContinuity = true;
        this.shakeContinuity(parmas);
      } else {
        this.isSingleOrContinuity = false;
        this.shakeSingle(parmas);
      }
    },
    getRecordlist(currentPage) /**抽奖记录 */ {
      if (this.isAPP) {
        this.isRecordlist = true;
        let parmas = {
          userGuid: localStorage.getItem("userguid"),
          token: localStorage.getItem("token"),
          platform: this.getPlatform()
        };
        axios
          .post(this.$interfaces.lotteryrecord, parmas)
          .then(res => {
            if (res.data.code == 200) {
              this.$nextTick(() => {
                Indicator.close();
              });
              let data = res.data.data;
              this.options = data.lotteryList;
              this.isLastPage = data.isLastPage;
              this.pageNum = data.pageNum;
              this.pages = data.pages;
              this.totalCount = data.totalCount;
            } else {
              this.$nextTick(() => {
                Indicator.open({
                  text: res.data.message,
                  spinnerType: "fading-circle"
                });
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.wx_share();
      }
    },
    Axios(buttonId, parmas) /**抽奖按钮的网络请求*/ {
      if (buttonId == -1) {
        axios
          .post(this.$interfaces.lottery, parmas)
          .then(res => {
            if (res.data.code == 200) {
              this.$nextTick(() => {
                Indicator.close();
              });
              let data = res.data.data;
              let icon_here = data.seatNumber;
              this.singleNum = icon_here;
              this.dicePoint = data.dicePoints;
              let num = this.dicePoint + "";
              this.singleResultImgUrl = diceObj[num];
              this.lotteryPrizeList = data.prizeList;
              this.isShowAnimateBoxFlag = true;
              clearTimeout(_timer);
              _timer = setTimeout(() => {
                this.isShowAnimateBoxFlag = false;
                this.isShowResultBoxFlag = true;
              }, 2000);

              this.getLotteryList(this.lotteryId);
            } else if (res.data.code == 500005) {
              this.toRecharge();
              this.isShowAnimateBoxFlag = false;
              this.isShowResultBoxFlag = false;
            } else if (res.data.code == 500006) {
              this.toRecharge();
              this.isShowAnimateBoxFlag = false;
              this.isShowResultBoxFlag = false;
            } else if (res.data.code == 500023) {
              this.toRecharge();
              this.isShowAnimateBoxFlag = false;
              this.isShowResultBoxFlag = false;
            } else {
              this.$nextTick(() => {
                Indicator.open({
                  text: res.data.message,
                  spinnerType: "fading-circle"
                });
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        axios
          .post(this.$interfaces.lottery, parmas)
          .then(res => {
            // console.log('lianyao:',res)
            if (res.data.code == 200) {
              this.$nextTick(() => {
                Indicator.close();
              });
              let data = res.data.data;
              let icon_here = data.seatNumber;
              this.singleNum = icon_here;
              // console.log("连摇玩家所在的位置::", this.singleNum);
              let num = this.singleNum + "";
              this.getImgArr(this.doubleCount);
              this.isShowResultBoxFlag = true;
              let prizeList = data.prizeList == null ? [] : data.prizeList;
              // console.log('prizeList:',prizeList)
              this.lotteryPrizeList = prizeList.sort(
                (a, b) => b.rarePrize - a.rarePrize
              );
              this.isShowAnimateBoxFlag = true; // 展示动画
              clearTimeout(_timer);
              _timer = setTimeout(() => {
                this.isShowAnimateBoxFlag = false;
                this.isShowResultBoxFlag = false;
                this.isResult = true;
              }, 2000);
              this.getLotteryList(this.lotteryId);
            } else if (res.data.code == 500005) {
              this.toRecharge();
              this.isShowAnimateBoxFlag = false;
              this.isShowResultBoxFlag = false;
            } else if (res.data.code == 500006) {
              this.toRecharge();
              this.isShowAnimateBoxFlag = false;
              this.isShowResultBoxFlag = false;
            } else if (res.data.code == 500023) {
              this.toRecharge();
              this.isShowAnimateBoxFlag = false;
              this.isShowResultBoxFlag = false;
            } else {
              this.$nextTick(() => {
                Indicator.open({
                  text: res.data.message,
                  spinnerType: "fading-circle"
                });
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    doAnimate(btnType) /**动画类型*/ {
      if (btnType !== -1) {
        this.isSingleOrContinuity = true; //连摇
        this.shakeContinuity(btnType);
      } else if (btnType == -1) {
        this.isSingleOrContinuity = false; //单摇
        this.shakeSingle(btnType);
      }
    },
    doAnimatAgain(parmas) {
      this.CloseResult();
      if (parmas !== -1) {
        this.isSingleOrContinuity = true; //连摇
        this.shakeContinuity(parmas);
      } else {
        this.isSingleOrContinuity = false; //单摇
        this.shakeSingle(parmas);
      }
    },
    getRecordlist(currentPage) /**抽奖记录 */ {
      if (this.isAPP) {
        this.isRecordlist = true;
        let parmas = {
          userGuid: localStorage.getItem("userguid"),
          token: localStorage.getItem("token"),
          platform: this.getPlatform()
        };
        axios
          .post(this.$interfaces.lotteryrecord, parmas)
          .then(res => {
            if (res.data.code == 200) {
              this.$nextTick(() => {
                Indicator.close();
              });
              let data = res.data.data;
              this.options = data.lotteryList;
              this.isLastPage = data.isLastPage;
              this.pageNum = data.pageNum;
              this.pages = data.pages;
              this.totalCount = data.totalCount;
            } else {
              this.$nextTick(() => {
                Indicator.open({
                  text: res.data.message,
                  spinnerType: "fading-circle"
                });
              });
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.wx_share();
      }
    },
    wx_share() /**app 唤起*/ {
      this.baseUrl = "https://a.app.qq.com/o/simple.jsp?pkgname=com.wzf.fan";
      if (this.isAndroid) {
        window.location.href =
          this.baseUrl + `&android_schema=${appUrlAndroid("100000")}`;
      } else if (this.isiOS) {
        let ua = navigator.userAgent.toLowerCase();
        if (ua.match(/QQ/i) == "qq") {
          this.isAppopen = true;
        } else {
          window.location.href = appUrlIOS("100000");
        }
      } else {
        window.location.href = "http://share.xiyacs.com/#/open";
      }
    },
    share() /**分享交互 */ {
      this.$bridge.callhandler({
        action: "open",
        object: "share",
        param: {
          title: "我是谜-每日一抽",
          desc: "每日来抽钻石、付费剧本、头像框、资料卡、剧本券等惊喜好礼",
          image: "https://woshimiimage.mvoicer.com/image/cxw/1592989869187",
          url: this.Url,
          platformType: 30
        }
      });
    },
    CloseResult() /**关闭抽奖结果弹窗*/ {
      this.isResult = false;
      this.im_here = this.singleNum;
    },
    closeRercod() /**抽奖记录弹窗关闭 */ {
      this.isRecordlist = false;
    },
    getGiftsInfo(data) /**礼物详情*/ {
      const { prizeId, prizeName, prizeImg } = data;
      this.prizeId = prizeId;
      this.prizeName = prizeName;
      this.prizeImg = prizeImg;
      this.isGiftInfo = true;
    },
    getLotteryList(lotteryId) /**礼物池数据 */ {
      let parmas = {
        userGuid: this.userguid,
        token: this.token,
        platform: this.getPlatform(),
        lotteryId: lotteryId || ""
      };
      axios
        .post(this.$interfaces.lotteryHome, parmas)
        .then(res => {
          if (res.data.code == 200) {
            this.$nextTick(() => {
              Indicator.close();
            });
            let data = res.data.data;
            this.lotteryId = data.lotteryId;
            this.userWallet = data.userWallet;
            this.advert = data.advert;
            this.watchAdvertFreeLottery = data.watchAdvertFreeLottery; //是否看视频免费 1 是 0 否
            this.im_here = data.seatNumber;
            this.lotteryButtonList = data.lotteryButtonList;
            this.lotteryButtonList.forEach((item, index) => {
              if (item.lotteryButtonId !== -1) {
                this.doubleCount = item.lotteryCount;
                this.doubleshakemoney = item.lotteryCountPrice;
                this.contiueBtnId = item.lotteryButtonId;
                this.icon_img = item.lotteryCountPriceType;
              } else if (item.lotteryButtonId == -1) {
                this.singlemoney = item.lotteryCountPrice;
                this.singleCount = item.lotteryCount;
                this.singleBtnId = item.lotteryButtonId;
                this.icon_img = item.lotteryCountPriceType;
              }
            });
            this.prizeList = data.prizeList;
            this.prizeList.map((item, index) => {
              item.id = index;
              if (index + 1 == this.singleNum) {
                this.isTagHere = true;
              } else {
                this.isTagHere = false;
              }
            });
            this.lotteryList = data.lotteryList;
            this.getinit(this.lotteryList);
          } else {
            this.$nextTick(() => {
              Indicator.open({
                text: res.data.message,
                spinnerType: "fading-circle"
              });
            });
          }
        })
        .catch(err => {
          this.$nextTick(() => {
            Indicator.open({
              text: err.message,
              spinnerType: "fading-circle"
            });
          });
        });
    },
    getInfo() /**获取用户信息*/ {
      return new Promise((reslove, reject) => {
        this.$bridge.callhandler(
          {
            action: "get",
            object: "userinfo"
          },
          res => {
            reslove(res);
          }
        );
      });
    },
    toRecharge() /**充值交互函数 */ {
      this.$bridge.callhandler(
        {
          action: "open",
          object: "recharge"
        },
        e => {}
      );
    },
    getPlatform() /**获取平台函数 */ {
      let platfrom;
      if (this.isAndroid) {
        platfrom = 1;
      } else {
        platfrom = 2;
      }
      return platfrom;
    },
    getVideo() /**视频js交互 */ {
      let DeviceVerify = window.localStorage.getItem("deviceVerify");
      if (
        this.isAndroid &&
        (DeviceVerify == false || DeviceVerify == "false")
      ) {
        this.isSimulator = true;
        this.isSimulatorMessage = "请使用移动端设备打开最新版APP参与抽奖";
        clearTimeout(_timer);
        _timer = setTimeout(() => {
          this.isSimulator = false;
        }, 3000);
      } else {
        this.getAdvert(this.advert.id, this.advert.channel);
      }
    },
    getAdvert(id, channel) /*交互函数*/ {
      this.$bridge.callhandler(
        {
          action: "open",
          object: "videoAd",
          param: {
            channel: channel,
            placementId: id
          }
        },
        e => {
          const json_Obj = JSON.parse(e);
          if (json_Obj.code == 1000) {
            this.getVideoLottery();
          } else if (json_Obj.code == 1001) {
            // console.log(json_Obj.msg)
            Toast(json_Obj.msg);
          } else {
            Toast(json_Obj.msg);
            // console.log(json_Obj.msg)
          }
        }
      );
    },
    getVideoLottery() /**视频激励抽奖*/ {
      let parmas = {
        userGuid: localStorage.getItem("userguid"),
        token: localStorage.getItem("token"),
        platform: this.getPlatform(),
        lotteryId: this.lotteryId
      };
      axios.post(this.$interfaces.videoLottery, parmas).then(res => {
        if (res.data.code == 200) {
          this.getLotteryList(this.lotteryId);
          this.$nextTick(() => {
            Indicator.close();
          });
          const data = res.data.data;
          this.isSingleOrContinuity = false;
          let icon_here = data.seatNumber;
          this.singleNum = icon_here;
          this.dicePoint = data.dicePoints;
          let num = this.dicePoint + "";
          this.singleResultImgUrl = diceObj[num];
          this.lotteryPrizeList = data.prizeList;
          this.isShowResultBoxFlag = true;
        } else {
          this.$nextTick(() => {
            Indicator.open({
              text: res.data.message,
              spinnerType: "fading-circle"
            });
          });
        }
      });
    }
  },
  components: {
    Rules: () => import("../component/lottery_rules"),
    Appopen: () => import("../../../component/Appopen"),
    Result: () => import("../component/lottery_result"),
    MapType: () => import("../component/lottery_map"),
    containerSelectOptions: () =>
      import("../component/container-select-options"),
    Tab: () => import("../component/lottery_tab"),
    Header: () => import("../component/lottery_header"),
    Lotterylist: () => import("../component/record_list"),
    Indicator
  }
};
</script>

<style lang="scss" scoped>
@import url("../../../assets/css/base.css");
.lottery_container {
  width: 100vw;
  position: relative;
  .share {
    background: url("../../../assets/images/lottery/home_page/share.png")
      no-repeat;
    background-size: cover;
    width: 1.025rem;
    height: 1.025rem;
    // border:0.025rem solid red;
    position: absolute;
    z-index: 2;
    right: 1rem;
    top: 3rem;
  }
  &.bg_26 {
    background: url("../../../assets/images/lottery/home_page/bg_26.jpg")
      no-repeat;
    background-size: cover;
    height: 66.2rem;
  }
  &.bg_20 {
    background: url("../../../assets/images/lottery/home_page/bg_20.jpg")
      no-repeat;
    background-size: cover;
    height: 60.675rem;
  }
  &.bg_14 {
    background: url("../../../assets/images/lottery/home_page/bg_14.jpg")
      no-repeat;
    background-size: cover;
    height: 54.025rem;
  }
  .rules {
    width: 100%;
    position: absolute;
    bottom: 0.5rem;
    left: 0;
  }
  .header {
    width: 100vw;
  }
  .tab {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    margin-top: 6.95rem;
    height: 1.7rem;
    .select-container {
      height: 1.7rem;
    }
  }
  .lottery_text {
    // background: url("../../../assets/images/lottery/home_page/gear_title.png")
    // no-repeat;
    // background-size: cover;
    // width: 6.775rem;
    // height: 0.525rem;
    margin: 0.3rem auto auto auto;
    font-family: "PingFang SC";
    font-weight: 600;
    color: rgba(255, 255, 255, 0.75);
    font-size: 0.4rem;
    height: 0.75rem;
    line-height: 0.75rem;
    -webkit-text-size-adjust: none;
    -webkit-transform: scale(0.9, 0.9);
  }
  .map {
    display: inline-block;
    width: 100%;
    margin-top: 1rem;
  }
  .btn {
    width: 100vw;
    position: relative;
    .video_img {
      background: url("../../../assets/images/lottery/home_page/ad.png")
        no-repeat;
      background-size: cover;
      width: 2.8rem;
      height: 2.8rem;
      position: absolute;
      top: 1.5rem;
      right: 0.25rem;
    }
    &.scrollFlag {
      width: 100vw;
      height: 6rem;
      background: -webkit-linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 1)
      );
      background: -moz-linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 1)
      );
      background: -o-linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 1)
      );
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 1)
      );
      border-radius: 0.075rem;
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 1;
    }
    .shake-sieve-container {
      ul {
        width: 100vw;
        display: flex;
        justify-content: center;
        align-items: center;
        .container {
          width: 6rem;
          height: 6rem;
          background: url("../../../assets/images/lottery/home_page/dice_once_btn.png")
            no-repeat center;
          background-size: cover;
          padding-top: 3.375rem;
          margin-right: 1.25rem;
          &.special {
            background: url("../../../assets/images/lottery/shaizi.gif")
              no-repeat center;
            background-size: cover;
          }
          p {
            font-family: "PingFang SC";
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            font-size: 0.5rem;
            height: 0.75rem;
            line-height: 0.75rem;
            .blue-color {
              font-size: 0.5rem;
              color: #8bf1fe;
            }
            &.litter-fz {
              background: url("../../../assets/images/lottery/home_page/dice_btn_font.png")
                no-repeat;
              background-size: cover;
              width: 2.25rem;
              height: 0.325rem;
              margin-left: auto;
              margin-right: auto;
            }
            .zhuan-bg {
              display: inline-block;
              width: 0.45rem;
              height: 0.375rem;
              &.jinbi {
                background: url("../../../assets/images/lottery/home_page/coin_dice.png")
                  no-repeat center;
                background-size: cover;
              }
              &.dimaon {
                background: url("../../../assets/images/lottery/home_page/diamond _dice.png")
                  no-repeat center;
                background-size: cover;
              }
              &.mining {
                background: url("../../../assets/images/lottery/home_page/mining_dice.png")
                  no-repeat center;
                background-size: cover;
              }
            }
          }
        }
      }
    }
  }
  .animate {
    width: 100vw;
    .animateAndResult {
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 999;
      .animate-gif {
        width: 100vw;
        height: 100vh;
        background: url("../../../assets/images/lottery/shaizianmite.gif")
          no-repeat center;
        background-size: cover;
        position: relative;
      }
      .result {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        .signleBox {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 10.475rem;
          height: 10.475rem;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
        }
        .closeBtn {
          width: 1.975rem;
          height: 1.975rem;
          background: url("../../../assets/images/lottery/home_page/close_dice.png")
            no-repeat center;
          background-size: cover;
          position: absolute;
          right: 0.5rem;
        }
        .step_num {
          font-size: 1.1rem;
          font-family: "PingFang SC";
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 1.15rem;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
        .continuityBox {
          position: relative;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 10.475rem;
          height: 10.475rem;
          background-position: center;
          background-repeat: no-repeat;
          background-size: cover;
          .continuityNumbers {
            position: absolute;
            right: -0.5rem;
            top: 0.5rem;
            ul {
              display: flex;
              li {
                width: 0.925rem;
                height: 0.975rem;
                background-position: center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
              }
            }
          }
        }
      }
    }
  }
  .result_info {
    width: 100%;
  }
  .ios_notic {
    width: 100%;
    font-size: 0.4rem;
    color: #766893;
    text-align: center;
    position: absolute;
    bottom: 1.25rem;
  }
  .isSimulator_notic {
    position: fixed;
    bottom: 30%;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(255, 255, 255, 0.8);
    height: 1.25rem;
    width: 70%;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    line-height: 1.25rem;
    font-size: 0.65rem;
    border-radius: 0.25rem;
  }
}
//        <!-- <p @click="isAPP ? share() : wx_share()">分享</p> -->
</style>



// WEBPACK FOOTER //
// src/components/wsm_lottery/view/lottery_home.vue